import React from 'react'
import dateHelpers from "../../helpers/DateHelper";
import {MdKeyboardArrowDown, MdKeyboardArrowUp} from "react-icons/md";
import {Button} from "reactstrap";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";

let resourceStrings = new LocalizedStrings(resource_strings);

const roundButton = {width: 50, height: 50, minWidth: 50, minHeight: 50, borderRadius: 25, padding: 0}

class StudentReportRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            detailsOpen: false
        };

        resourceStrings.setLanguage(localeHelpers.currentLocale());
    }

    toggleDetails(e) {
        e.preventDefault();
        this.setState({detailsOpen: !this.state.detailsOpen})
    }

    render() {
        return (
            <>
                <div
                    style={{
                    display: "flex",
                    width: "100%",
                    flexFlow: "row",
                    paddingLeft: 20,
                    paddingTop: 10,
                    paddingBottom: 10,
                    paddingRight: 20,
                    marginBottom: 10,
                    flexWrap: "wrap",
                    alignItems: "center",
                    backgroundColor: "#555566",
                    justifyContent: "space-between",
                    borderRadius: 40
                }}>
                    <div style={{
                        display: "flex",
                        flexFlow: "row",
                        flexWrap: "wrap",
                        alignItems: "center",
                        justifyContent: "space-between",
                        minWidth: window.innerWidth / 2,
                        color: "white",
                        maxWidth: window.innerWidth / 2
                    }}>

                        <div style={{
                            display: "flex",
                            flexFlow: "column",
                            flexWrap: "wrap",
                            alignItems: "start",
                            justifyContent: "start",
                            minWidth: window.innerWidth / 2.5,
                            color: "white",
                            maxWidth: window.innerWidth / 2.5
                        }}>
                            <div className="mb-0 text-sm font-weight-bold" style={{textDecoration: "underline", cursor: "pointer"}} onClick={e => this.goToStudent(e)}>
                                {this.props.student && this.props.student.name ? this.props.student.name.substring(0, 30) : "..."}
                            </div>

                            {/*<div style={{fontWeight: 500, fontSize: "0.7rem"}}>*/}
                            {/*    {this.state.yclass && this.state.yclass.room ? this.state.yclass.room : ""}*/}
                            {/*</div>*/}
                        </div>

                        {/*<div style={{fontWeight: 500, fontSize: "0.8rem"}}>*/}
                        {/*    {this.state.yclass && this.state.yclass.teacher ? this.state.yclass.teacher : ""}*/}
                        {/*</div>*/}

                        {/*<div style={{fontWeight: 700, fontSize: "1.1 rem"}}>*/}
                        {/*    {this.renderBadge()}*/}
                        {/*    {this.state.yclass && this.state.yclass.students ? this.state.yclass.students.toString() : "0"}*/}
                        {/*    <MdPerson style={{marginBottom: 2}}/>*/}
                        {/*</div>*/}

                    </div>

                    <div style={{
                        display: "flex",
                        flexFlow: "row",
                        flexWrap: "wrap",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}>

                        <div style={{fontWeight: 600, fontSize: "0.8rem", color: "white"}}>
                            {(this.props.yclasses || []).length} {resourceStrings.classes}
                        </div>

                        <span style={{marginLeft: 20}}>
                    <Button
                        style={roundButton}
                        className="btn-icon ct-example-tooltip-static"
                        color={"secondary"}
                        onClick={e => this.toggleDetails(e)}
                    >
                        {this.state.detailsOpen ? (<MdKeyboardArrowUp size={22}/>) : (<MdKeyboardArrowDown size={22}/>)}
                    </Button>
                    </span>
                    </div>
                </div>
                {this.state.detailsOpen &&
                <div style={{
                    display: "flex",
                    width: "100%",
                    flexFlow: "row",
                    paddingLeft: 20,
                    paddingBottom: 10,
                    paddingRight: 20,
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "left",
                }}>
                    {this.props.yclasses &&
                    <>
                        {this.props.yclasses.map((yclass, index) => {
                            return (
                                <div key={`cl_${yclass.id}`}
                                    onClick={(e) => {
                                    this.goToClass(e, yclass.id)
                                }}
                                     style={{
                                         color: "#c26b1b",
                                         background: "white",
                                         marginBottom: 10,
                                         marginRight: 10,
                                         paddingTop: 6,
                                         maxHeight: 50,
                                         minHeight: 50,
                                         paddingBottom: 6,
                                         paddingLeft: 16,
                                         paddingRight: 16,
                                         borderRadius: 24,
                                         display: "flex",
                                         flexFlow: "column",
                                         justifyContent: "center",
                                         alignItems: "start",
                                         cursor: "pointer"
                                     }}>
                                    <div style={{fontSize: "0.8rem", fontWeight: 700}}>
                                        {yclass.name}
                                    </div>

                                    <div style={{fontSize: "0.7rem", fontWeight: 500}}>
                                        {dateHelpers.formatDate(new Date(yclass.date))} {" "} {yclass.start}
                                    </div>
                                </div>
                            )
                        })}
                    </>
                    }
                </div>
                }
            </>
        )
    }

    goToClass(e, id) {
        e.stopPropagation();
        this.props.goToClass(id)
    }

    goToStudent(e) {
        e.stopPropagation();
        this.props.goToStudent(this.props.student.id)
    }
}

export default StudentReportRow;